module.exports = __webpack_public_path__ + "static/media/pix.66016b8d.png";